const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Forma-1-copy-12",
    serifId: "Forma 1 copy 12",
    transform: "matrix(1,0,0,1,-1224.01,-797.991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1246.35,813.091C1246.42,813.022 1246.52,812.988 1246.63,812.988C1246.74,812.988 1246.83,813.022 1246.91,813.091C1247.07,813.229 1247.07,813.454 1246.91,813.592L1241.96,817.991L1246.91,822.391C1247.07,822.529 1247.07,822.753 1246.91,822.891C1246.76,823.029 1246.5,823.029 1246.35,822.891L1241.11,818.241C1240.96,818.103 1240.96,817.879 1241.11,817.741L1246.35,813.091Z",
    style: {
      fill: "rgb(79,79,79)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevar);
export default __webpack_public_path__ + "static/media/prevar.edc8c02e3efc4ad2f74090d342649821.svg";
export { ForwardRef as ReactComponent };